import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import ReactNotification from "react-notifications-component";
import * as serviceWorker from "./serviceWorker";
import "react-notifications-component/dist/theme.css"

ReactDOM.render(
  <>
    <ReactNotification />
    <App />
  </>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
